import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const GASOILANDLUBRICANTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GasOilAndLubricantType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const GASOILANDLUBRICANTTYPE_CONFIG = {
  entityName: 'GasOilAndLubricantType',
  localizationKey: 'General::Entity.GasOilAndLubricantType',
  fields: GASOILANDLUBRICANTTYPE_FIELDS,
  permission: 'GeneralConsumables.GasOilAndLubricantTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
